import { InjectionToken } from '@angular/core';

export const NB_AUTH_TOKEN_INTERCEPTOR_FILTER = new InjectionToken<string>(
	'NB_AUTH_TOKEN_INTERCEPTOR_FILTER'
);

export const AUTH_INTERCEPTOR_HEADER = new InjectionToken<string>(
	'AUTH_INTERCEPTOR_HEADER'
);

export const notInterceptedApiEndpoint = [
	// 'ModificaPassword',
	'/apiNeta2DPortal/v1.0/ResetPassword',
	'/apiNeta2DPortal/v1.0/CheckResetPassword',
	'/apiNeta2DPortal/v1.0/Logout',
];
